import React from 'react';
import Typography from '@mui/material/Typography';

function OriginalUploader(props) {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '20%',
            alignItems: 'center'
        }}>
            <div>
                <img src={"https://cdn.coursemos.kr/images/working.gif"} alt="Working" />
            </div>

            <Typography id="text-pre-loading" variant="h6" style={{ marginTop: "15px" }}>
                준비 중입니다...
            </Typography>
        </div>
    );
}

export default OriginalUploader;